<script setup lang="ts">
import BaseButton from '@/common/components/molecules/baseButton/BaseButton.vue';
import { type Props, type Emit, setup } from './supportMenuElement.setup';

defineProps<Props>();
const emit = defineEmits<Emit>();

const { t, onHoverButton, onClickButton } = setup(emit);
</script>

<template>
  <li :class="['menu-element', 'support-menu', { selected }]">
    <base-button
      tag="button"
      type="button"
      class="menu-element__title support-menu__title"
      :data-menu="info.value"
      @mouseenter="onHoverButton"
      @click="onClickButton"
    >
      <div class="menu-element__title-inner support-menu__title-inner">
        <div class="menu-element__item-icon">
          <ev-icon
            size="medium"
            icon="ev-icon-help"
          />
        </div>
        <h3>{{ t('WORD.USER_MANUAL') }}</h3>
        <div class="menu-element__arrow-icon right" />
      </div>
    </base-button>
  </li>
</template>

<style scoped lang="scss">
.support-menu {
  .base-menu.expanded & {
    width: 100%;
  }

  &__title {
    .base-menu.expanded & {
      width: 100%;
      padding: 8px;
    }
  }

  &__title-inner {
    height: 100%;
    padding-left: 0;

    :deep(.menu-element__item-icon) {
      background-color: transparent !important;
    }

    :deep(.menu-element__item-icon i) {
      font-size: var(--gnb-menu-icon-size);
      color: var(--gnb-menu-icon-color) !important;
    }
  }

  &.selected {
    .menu-element__title {
      background-color: rgb(var(--color-gray-00-00-rgb), 0.12);
    }
  }
}
</style>
